import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "item-tree-switcher",
  class: "uk-flex"
}
const _hoisted_2 = ["uk-icon"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "switcher-icon",
      "uk-icon": `icon: ${_ctx.icon}; ratio: 1`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('switcherToggled')))
    }, null, 8, _hoisted_2),
    _createElementVNode("span", null, _toDisplayString(_ctx.value
        ? _ctx.$t('index_templates.item_tree_switcher.tree_view')
        : _ctx.$t('index_templates.item_tree_switcher.table_view')), 1)
  ]))
}